import React from 'react';
import { useNavigate } from 'react-router-dom';
import URL from '@/common/routes/Url';
import './css/overviewStyle.scss';

const Overview: React.FC = () => {
  const navigate = useNavigate();

  const tologin = () => {
    navigate(URL.privacy);
  }

  return (
    <div className='overview'>
      <header>
        <h1 className="ttl">
          <img src="/manual/sample/images/logo.png" alt="次世代ホワイトボード みてリンク" />
        </h1>
        <ul className="list">
          <li>
            <a href="/signin">ログイン</a>
          </li>
          <li>
            <a href="/home">ホーム</a>
          </li>
          <li>
            <a href="https://si.mitani-corp.co.jp/lp/mitelink-form/">
              お問い合わせ
            </a>
          </li>
          <li>
            <a href="/home/privacy">プライバシーポリシー</a>
          </li>
          <li>
            <a href="/manual/terms.pdf" target='_blank'>
              利用規約
            </a>
          </li>
        </ul>
      </header>
      <body>
        <h2>会社概要</h2>
        <table>
          <tbody>
            <tr>
              <th>会社名</th>
              <td>三谷商事株式会社</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>〒910-8510<br/>福井県福井市豊島1-3-1 第3三谷ビル</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>〒910-8510　福井県福井市豊島1-3-1 第3三谷ビル</td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td><a href="tel:0120-188-022">0120-188-022</a></td>
            </tr>
            <tr>
              <th>ホームページ</th>
              <td><a href="https://www.mitani-corp.co.jp/" target='_blank'>https://www.mitani-corp.co.jp/</a></td>
            </tr>
            <tr>
              <th>設立</th>
              <td>1946年3月20日（1914年3月創業）</td>
            </tr>
            <tr>
              <th>資本金</th>
              <td>50億869万円</td>
            </tr>
            <tr>
              <th>従業員数</th>
              <td>644名</td>
            </tr>
            <tr>
              <th>本社</th>
              <td>福井本社 : 福井県福井市豊島1-3-1<br/>
                  東京本社 : 東京都千代田区丸の内1-6-5　丸の内北口ビルディング2F</td>
            </tr>
            <tr>
              <th>適格請求書登録番号</th>
              <td><a href='https://www.invoice-kohyo.nta.go.jp/regno-search/detail?selRegNo=7210001004022' target='_blank'>T7210001004022</a></td>
            </tr>
          </tbody>
        </table>
      </body>
      <footer>
        <div className="infoWrap">
          <div className="flex">
            <div className="box">
              <img src="/manual/sample/images/ftr_logo.png" alt="三谷商事株式会社" />
              <img src="/manual/sample/images/ftr_name.png" alt="情報システム事業部システム部" />
            </div>
            <div className="box2">
              <div className="info">
                <img src="/manual/sample/images/ftr_icon_phone.png" alt="フリーダイヤル" />
                <a href="tel:0120-188-022">0120-188-022</a>
              </div>
              <div className="info2">受付時間 9:00-12:00 13:00-17:00</div>
              <div className="info3">
                <img src="/manual/sample/images/ftr_icon_mail.png" alt="メールアドレス" />
                <a href="mailto:mitelink@mitani-corp.co.jp">
                  mitelink@mitani-corp.co.jp
                </a>
              </div>
            </div>
          </div>
          <div className='footer'>
            <ul className="md-flex">
              <li><a href="/home">ホーム</a></li>
              <li className='ll'><a href="/home/overview">会社概要</a></li>
              <li className='ll'><a href="/home/sct">特定商取引法に基づく表記</a></li>
              <li className='ll'><a href="/home/privacy">プライバシーポリシー</a></li>
              <li className='ll'><a href="/manual/terms.pdf" target='_blank'>利用規約</a></li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
export default Overview;